import { createTheme, ThemeProvider } from "@mui/material/styles";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  CssBaseline,
  Avatar,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { Container, Box } from "@mui/system";
import React, { useState } from "react"
import { useAppDispatch } from "../../redux/store";
import { planoAPI, useLoginMutation } from "../../redux/features/cache";
import { setToken } from "../../redux/features/appStateSlice";

const theme = createTheme();

export interface IConnectionPageProps { }

export default function PlanogrammePage(props: IConnectionPageProps) {
  const dispatch = useAppDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [connectionFailed, setConnectionFailed] = useState(false);
  const [login] = useLoginMutation();

  const onChangeUsername = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setUsername(e.target.value);
  };
  const onChangePassword = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setPassword(e.target.value);
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let result = await login({ user: username, password }).unwrap();
    dispatch(planoAPI.util.resetApiState());
    const succes = result.succes;
    if (succes) {
      localStorage.setItem('token', result.token);
      localStorage.setItem('user', username)
      dispatch(setToken(result.token));
      setConnectionFailed(false);
    } else {
      setConnectionFailed(true);
    }
  };


  return (
    <div>
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Authentification
            </Typography>
            <Box
              component="form"
              onSubmit={(e) => {
                handleSubmit(e);
              }}
              sx={{ mt: 1 }}
            >
              <Alert severity="error" hidden={!connectionFailed}>La connexion a échoué, réessayer!</Alert>
              <TextField
                margin="normal"
                required
                onChange={(e) => {
                  onChangeUsername(e);
                }}
                fullWidth
                id="email"
                label="Applicat user"
                name="user"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                onChange={(e) => {
                  onChangePassword(e);
                }}
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Se connecter
              </Button>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </div>
  );
}

